import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import * as TechpackModule from './modules/techpack'
import * as CompaniesModule from './modules/companies'
import { folderModule } from './modules/folders'
import { techpacksModule } from './modules/techpacks'
import { userModule } from './modules/user'

Vue.use(Vuex)

const storeOpts: StoreOptions<unknown> = {
  modules: {
    techpack: TechpackModule,
    companies: CompaniesModule,
    folders: folderModule,
    techpacks: techpacksModule,
    user: userModule
  }
}

export default new Vuex.Store<unknown>(storeOpts)
